import { render, staticRenderFns } from "./AddedBy.vue?vue&type=template&id=582bb44a&scoped=true"
import script from "./AddedBy.vue?vue&type=script&lang=ts"
export * from "./AddedBy.vue?vue&type=script&lang=ts"
import style0 from "./AddedBy.vue?vue&type=style&index=0&id=582bb44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bb44a",
  null
  
)

export default component.exports